/** Alíquota/percentual em Plex Mono tabular. `value` é fração decimal (0.0325 = 3,25%). */
import { fmtDeltaPct, fmtPct } from '@/lib/format';

export interface PercentProps {
  value: number;
  /** Mostra sinal (+/−) — usar para variações (ex.: reajuste de preço). */
  signed?: boolean;
  className?: string;
}

export function Percent({ value, signed = false, className }: PercentProps) {
  return (
    <span className={['percent', className].filter(Boolean).join(' ')}>
      {signed ? fmtDeltaPct(value) : fmtPct(value)}
    </span>
  );
}
